<template>
    <div>
        <b-row>
            <b-col cols="12" md="3">
                <b-form-group :label="$t('code')">
                    <div class="label-as-input">{{ isNotNullValue(formData.id) }}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="9">
                <b-form-group :label="$t('subject')">
                    <b-input-group :prepend="$t('variable_language')" class="mb-2">
                        <div class="label-as-input font-weight-bold">
                            {{ isNotNullValue(formData.subject) }}
                        </div>
                    </b-input-group>
                    <b-input-group prepend="EN" v-if="formData.subject_en">
                        <div class="label-as-input font-weight-bold">
                            {{ isNotNullValue(formData.subject_en) }}
                        </div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>

        <!-- Full-width Explanations (Açıklama TR & EN) -->
        <b-row class="mb-3">
            <b-col cols="12" :lg="formData.explanation_en ? '6' : '12'" class="mb-3 mb-lg-0" v-if="formData.explanation">
                <b-form-group :label="$t('explanation') + ' (' + $t('variable_language') + ')'">
                    <div class="p-3 border rounded bg-white shadow-sm overflow-auto" style="max-height: 480px; min-height: 140px; font-size: 14px; line-height: 1.6;">
                        <div v-html="formData.explanation"></div>
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="12" :lg="formData.explanation ? '6' : '12'" v-if="formData.explanation_en">
                <b-form-group :label="$t('explanation') + ' (EN)'">
                    <div class="p-3 border rounded bg-white shadow-sm overflow-auto" style="max-height: 480px; min-height: 140px; font-size: 14px; line-height: 1.6;">
                        <div v-html="formData.explanation_en"></div>
                    </div>
                </b-form-group>
            </b-col>
        </b-row>

        <!-- Metadata Info -->
        <b-row class="mb-3">
            <b-col cols="12" md="3">
                <b-form-group :label="$t('start_date')">
                    <div class="label-as-input">{{ isNotNullValue(formData.start_date) }}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
                <b-form-group :label="$t('end_date')">
                    <div class="label-as-input">{{ isNotNullValue(formData.end_date) }}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
                <b-form-group :label="$t('status')">
                    <div class="label-as-input">
                        <span :class="formData.status === 'a' ? 'badge badge-success px-2 py-1' : 'badge badge-secondary px-2 py-1'">
                            {{ formData.status === 'a' ? $t('active') : $t('passive') }}
                        </span>
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
                <b-form-group :label="$t('file')">
                    <div v-if="fileObj" class="d-flex align-items-center justify-content-between p-2 border rounded bg-light">
                        <div class="d-flex align-items-center overflow-hidden mr-2">
                            <i class="ri-file-text-line font-size-18 text-primary mr-2 flex-shrink-0"></i>
                            <span class="font-weight-bold text-truncate small" :title="fileName">{{ fileName }}</span>
                        </div>
                        <div class="d-flex align-items-center flex-shrink-0">
                            <b-button size="sm" variant="primary" class="btn-xs px-2 py-1" @click="downloadAnnouncementFile(fileObj)" title="İndir">
                                <i class="ri-download-line mr-1"></i> {{ $t('download') || 'İndir' }}
                            </b-button>
                        </div>
                    </div>
                    <div v-else class="label-as-input">{{ isNotNullValue(fileName) }}</div>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12" md="6" v-if="showRoles && showRoles.length">
                <b-form-group :label="$t('roles')">
                    <div class="label-as-input">
                        <span v-for="role in showRoles" :key="role.id" class="badge badge-light border mr-1 mb-1 p-1">
                            {{ getLocaleText(role, 'explanation') }}
                        </span>
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6" v-if="showPrograms && showPrograms.length">
                <b-form-group :label="$t('program_level')">
                    <div class="label-as-input">
                        <span v-for="level in showPrograms" :key="level.code" class="badge badge-light border mr-1 mb-1 p-1">
                            {{ getLocaleText(level, 'name') }}
                        </span>
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="12" v-if="formData.student_program_ids">
                <b-form-group :label="$t('student_program_id')">
                    <lined-textarea v-model="formData.student_program_ids"
                                    :nowrap="false"
                                    :disabled="true"
                                    :styles="{ height: '120px', resize: 'both' }">
                    </lined-textarea>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    // Services
    import AnnouncementsService from '@/services/AnnouncementsService';
    import RoleService from "@/services/RoleService";
    import ParameterService from "@/services/ParameterService";
    import qs from "qs";
    import LinedTextarea from "@/components/elements/LinedTextarea.vue";

    export default {
        components: {
            LinedTextarea

        },
        props: {
            formId: {
                type: Number
            }
        },
        data() {
            return {
                formData: {},
                showRoles:[],
                showPrograms:[],
                showStatus:null,
                fileName:null
            }
        },
        computed: {
            fileObj() {
                if (this.formData.file && typeof this.formData.file === 'object' && this.formData.file.uuid) {
                    return this.formData.file;
                }
                return null;
            }
        },
        async created() {
            await this.get(this.formId)
             this.getPrograms()
        },
        methods: {
            fileViewUrl(uuid) {
                return AnnouncementsService.getFileUrl(uuid);
            },
            fileDownloadUrl(uuid) {
                return AnnouncementsService.getDownloadUrl(uuid);
            },
            downloadAnnouncementFile(fileObj) {
                if (!fileObj || !fileObj.uuid) return;
                const fileName = fileObj.file_name || fileObj.name || this.fileName || 'belge';
                AnnouncementsService.downloadFile(fileObj.uuid).then(response => {
                    this._downloadFile(response, fileName);
                }).catch(e => {
                    this.showErrors(e);
                });
            },
            get(id) {
                AnnouncementsService.get(id)
                              .then(response => {
                                  this.formData = response.data.data;
                                  this.formData.student_program_ids=response.data.data.student_program_ids[0]
                                  this.fileName=response.data.data.file.file_name
                                  this.showStatus=this.formData.status
                                  this.getRoles(this.formData.roles)
                                  this.getPrograms(this.formData.program_level)
                              })
                              .catch(e => {
                                  this.showErrors(e)
                              })

            },
            getRoles(value) {
                const selectedRoles = []
                value.forEach(item=>{
                    selectedRoles.push(parseInt(item))
                })
                const config = {
                    params: {
                        limit: -1
                    }
                };
                RoleService.getAll(config)
                    .then(response => {
                        const data = response.data.data;
                        data.forEach(itm=>{
                              if (selectedRoles.includes(itm.id)){
                                  this.showRoles.push(itm)
                              }
                        })

                    })
                    .catch(e => {
                        this.showErrors(e);
                    });
            },
            getPrograms(value){
                let selectedPrograms=value
                const config = {
                    params: {
                        filter: {
                            parameter_code: 'program_levels',
                        },
                        sort: 'name',
                        limit: -1,
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false}),
                };
                ParameterService.getAllItems(config)
                    .then((response) => {
                        let data=response.data.data
                        data.forEach(itm=>{
                            if (selectedPrograms.includes(itm.code)){
                               this.showPrograms.push(itm)
                            }
                        })
                    }).catch(e=>{
                        this.showErrors(e)
                })

            }

        }
    }
</script>
